export default __webpack_public_path__ + "static/media/elite.773eb993.svg";